
import React from 'react';
import { MentionUser } from '@/hooks/useUserMentions';
import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';

interface MentionDropdownProps {
  users: MentionUser[];
  selectedIndex: number;
  onSelect: (user: MentionUser) => void;
  visible: boolean;
}

export const MentionDropdown = ({ users, selectedIndex, onSelect, visible }: MentionDropdownProps) => {
  if (!visible || users.length === 0) return null;

  return (
    <div className="absolute bottom-full left-0 right-0 bg-white border border-gray-200 rounded-lg shadow-lg max-h-48 overflow-y-auto z-50 mb-1">
      {users.map((user, index) => (
        <button
          key={user.id}
          onClick={() => onSelect(user)}
          className={`w-full flex items-center space-x-2 px-3 py-2 text-left hover:bg-gray-50 ${
            index === selectedIndex ? 'bg-blue-50 border-l-2 border-blue-500' : ''
          }`}
        >
          <Avatar className="w-6 h-6">
            <AvatarImage 
              src={user.avatar_url || ''} 
              alt={user.farm_name || user.username || 'User'} 
            />
            <AvatarFallback className="text-xs">
              {(user.farm_name || user.username || 'U')[0].toUpperCase()}
            </AvatarFallback>
          </Avatar>
          <div className="flex-1 min-w-0">
            <div className="font-medium text-sm text-gray-900 truncate">
              {user.farm_name || 'Unknown Farm'}
            </div>
            <div className="text-xs text-gray-500 truncate">
              @{user.username || 'unknown'}
            </div>
          </div>
        </button>
      ))}
    </div>
  );
};
